// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_5p-4";
export var collapsed = "_5p-1";
export var headerBar = "_5p-0";
export var leftHeaderContent = "_5p-3";
export var subjectContainer = "_5p-2";